import { Link } from "gatsby";
import React from "react";

const StepTab = ({ tabClass, activeTab }) => {
  return (
    <div className="flex flex-row items-start mt-[2vw] md:mt-0">
      {/* Tabs */}
      <div className="flex flex-1 justify-center gap-[4vw] xl:gap-[1vw] mb-[4vw] xl:mb-[2vw]">
        {[1, 2, 3, 4, 5].map((tab) => (
          <button
            key={tab}
            className={`w-[8vw] md:w-[5vw] xl:w-[3vw] h-[8vw] md:h-[5vw] xl:h-[3vw] rounded-md text-[4vw] md:text-[2vw] xl:text-[1.2vw] ${tabClass(
              tab
            )}`}
          >
            {tab}
          </button>
        ))}
      </div>

      {/* Back / Begin Again Button */}
      {activeTab > 1 && <div className="ml-auto items-center">
        <Link to="/greet-services">
          <button className="font-redhatMedium px-[2vw] py-[1.2vw] md:py-[0.5vw] rounded-md bg-primary text-white text-[3.5vw] md:text-[2vw] xl:text-[1.2vw]">
            Begin Again
          </button>
        </Link>
      </div>}
    </div>
  );
};

export default StepTab;
